import React from "react";
import DailyReport from "app/modules/DailyReport";

export default function DailyExpiredReportPage() {
    return <DailyReport/>
}